import { string } from 'prop-types';
import React from 'react';

import Editorial from 'shared/components/content/Editorial';
import HTMLContent from 'shared/components/HTMLContent';

import Article from './Article';

const Article1 = ({ title, body }) => (
  <Article index="1">
    <h1>{title}</h1>
    <div className="body">
      <Editorial>
        <HTMLContent content={body} />
      </Editorial>
    </div>
  </Article>
);

Article1.propTypes = {
  title: string.isRequired,
  body: string,
};

export default Article1;
